import { API_BASE_URL } from "../config";

let isRedirecting = false;

// Вход через ComradeMajor. Если сессия ComradeMajor ещё жива, форма логина не показывается:
// браузер сразу возвращается обратно на текущую страницу.
export const redirectToLogin = () => {
  if (isRedirecting) return;
  isRedirecting = true;

  const { pathname, search } = window.location;
  window.location.assign(
    `${API_BASE_URL}/api/auth/login?returnUrl=${encodeURIComponent(pathname + search)}`
  );
};

// Выход из приложения и из ComradeMajor. Это навигация (POST-форма), а не fetch:
// ответ — цепочка редиректов через ComradeMajor.
export const logout = () => {
  const form = document.createElement("form");
  form.method = "post";
  form.action = `${API_BASE_URL}/api/auth/logout`;
  document.body.appendChild(form);
  form.submit();
};

// SignalR не сообщает код ответа при обрыве WebSocket — уточняем, жива ли сессия.
export const checkSession = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/auth/me`, {
      credentials: "include",
    });
    if (response.status === 401) redirectToLogin();
  } catch {
    // Сервер недоступен — не повод уходить на вход, переподключение продолжится.
  }
};
